<template>
  <div v-if="loading" class="console-state">
    <p class="console-page__placeholder">{{ loadingMessage }}</p>
  </div>

  <div v-else-if="error" class="alert alert--error">
    {{ error }}
  </div>

  <div v-else-if="isEmpty" class="console-state">
    <p class="console-page__placeholder">{{ emptyMessage }}</p>
  </div>

  <slot v-else />
</template>

<script setup>
defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: '',
  },
  isEmpty: {
    type: Boolean,
    default: false,
  },
  loadingMessage: {
    type: String,
    default: 'Loading...',
  },
  emptyMessage: {
    type: String,
    default: 'No results found.',
  },
})
</script>
